import type { ReactNode } from "react"

interface Props {
  condition: boolean
  yes?: ReactNode
  no?: ReactNode
  children?: ReactNode
}

export default function If(props: Props) {
  if (props.condition) {
    if (props.yes) {
      return props.yes || null
    } else {
      return props.children || null
    }
  } else {
    return props.no || null
  }
}
